import React from 'react'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { AlertTriangle } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { Account } from 'screens/BrandKit/SourceMaterials/SourceCreationModal/Account'
import { TacticIntegrationDropdown } from '../TacticIntegrationDropdown'
import { TacticIntegrationListVariant } from '../TacticIntegrationList'
import { NoContentInBrandPlan } from './NoContentInBrandPlan'
import Styles from './TacticIntegration.module.scss'
import cx from 'classnames'

interface DisconnectedIntegrationProps {
  integration: ExternalIntegration
  index: number
  variant?: TacticIntegrationListVariant
}

export const DisconnectedIntegration: React.FC<DisconnectedIntegrationProps> = ({ integration, index, variant }) => {
  return (
    <div className={cx(Styles.tacticIntegration, Styles.isDisconnected)}>
      <Text variant="smallList">
        <div className={Styles.indexIndicator}>{index} </div>
      </Text>

      <div className={Styles.tacticName}>
        <Account source={integration} avatarSize={35} />
      </div>

      {variant === 'integrations_page' ? <NoContentInBrandPlan integration={integration} /> : undefined}

      <div className={Styles.connectedStatus}>
        <div className={Styles.errorIcon}>
          <AlertTriangle size={14} color="var(--light-100)" />
        </div>
        <Text variant="largeList" color="var(--red-50)">
          Retry Connection
        </Text>
      </div>

      <TacticIntegrationDropdown integration={integration} refreshColor="var(--red-50)" variant={variant} />
    </div>
  )
}
